var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsertLinkFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.27235 17.7276C5.06319 16.5184 5.06319 14.5526 6.27235 13.3435L9.10077 10.5151L7.75727 9.17156L4.92884 12C2.97723 13.9516 2.97723 17.1194 4.92884 19.0711C6.88046 21.0227 10.0483 21.0227 11.9999 19.0711L14.8283 16.2426L13.4848 14.8991L10.6564 17.7276C9.44726 18.9367 7.4815 18.9367 6.27235 17.7276ZM9.87859 15.5355L15.5354 9.87867L14.1212 8.46445L8.46438 14.1213L9.87859 15.5355ZM11.9999 4.92892L9.17149 7.75735L10.515 9.10085L13.3434 6.27242C14.5526 5.06327 16.5183 5.06327 17.7275 6.27242C18.9366 7.48158 18.9366 9.44733 17.7275 10.6565L14.8991 13.4849L16.2426 14.8284L19.071 12C21.0226 10.0484 21.0226 6.88054 19.071 4.92892C17.1194 2.97731 13.9515 2.97731 11.9999 4.92892Z",
    fill: "#3D1CAF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertLinkFilled);
export default __webpack_public_path__ + "static/media/InsertLinkFilled.49e4589fcbeafdbdbf7eead7887868a5.svg";
export { ForwardRef as ReactComponent };